import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { Option } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_ROLE_BY_ID';
interface Params {
  id?: string;
}

const useGetOrganizationByIdQuery = ({ id }: Params) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id],
    () => api.get(API_URL.ORGANIZATIONS_SHORT_BY_ID(id || '')),
    {
      enabled: !!id,
    }
  );

  const formattedData: Option | null = useMemo(() => {
    if (!data?.data) {
      return null;
    }
    const { id, name, short_name } = data?.data || {};

    return {
      key: `${id || ''}`,
      title: name || short_name || '',
      value: name || short_name || '',
    };
  }, [data?.data]);

  return {
    isLoading,
    data: formattedData,
    isSuccess,
  };
};

export default useGetOrganizationByIdQuery;
